import { Checkbox, FormControlLabel } from "@mui/material";
import { useAppDispatch } from "../../../../Redux/hooks";
import { updateResponse } from "../../../../Redux/reducers/providerConsentSlice";

type Props = {
  currentBlock: any;
};

const CheckboxField = ({ currentBlock }: Props) => {
  const dispatch = useAppDispatch();
  const label = currentBlock?.label;
  const checked = currentBlock?.response?.checked;

  const handleChange = (_: any, checked: boolean) => {
    if (currentBlock.editable)
      dispatch(
        updateResponse({
          blockId: currentBlock.id,
          key: "checked",
          value: checked,
        })
      );
  };

  return (
    <FormControlLabel
      control={<Checkbox checked={checked ?? false} onChange={handleChange} />}
      label={label}
      sx={{ display: "block" }}
    />
  );
};
export default CheckboxField;
